/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Save_Changes_ButtonInputs */



/**
* | output |
* | --- |
* | "Save Changes" |
*
* @param {Tags_Manager_Save_Changes_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_save_changes_button = /** @type {((inputs?: Tags_Manager_Save_Changes_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Save_Changes_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer les modifications")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva modifiche")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить изменения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar cambios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変更を保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिवर्तनों को सुरक्षित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar alterações")
	return /** @type {LocalizedString} */ ("Save Changes")
});